'use client';
import { FC } from 'react';
import img from '@/images/help-dask.png';
import Image from 'next/image';
import { socials } from '@/data/defaultValue';

interface FloatingBtnProps {
  className?: string;
}

const FloatingBtn: FC<FloatingBtnProps> = () => {
  return (
    <div className=' group fixed bottom-0 right-0 md:bottom-5 md:right-10 p-2 flex items-end justify-end w-24 h-24'>
      <div className='text-white shadow-xl flex items-center justify-center p-2 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 z-50 absolute '>
        <Image
          width={35}
          height={35}
          src={img}
          className='object-cover'
          alt='support'
        />
      </div>

      <div className='absolute rounded-full transition-all duration-\[0.2s\] ease-out scale-x-0 group-hover:scale-x-100 group-hover:-translate-y-16 flex p-2 hover:p-3 bg-blue-300 hover:bg-blue-400 text-white cursor-pointer'>
        <a target='_blank' href={socials[0].href} rel='noopener noreferrer'>
          <Image
            width={20}
            height={20}
            src={socials[0].icon}
            alt='facebook icon'
          />
        </a>
      </div>

      <div className='absolute rounded-full transition-all duration-\[0.2s\] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-x-16 flex p-2 hover:p-3 bg-green-300 scale-100 hover:bg-green-400 text-white cursor-pointer'>
        <a target='_blank' href={socials[1].href} rel='noopener noreferrer'>
          <Image
            width={20}
            height={20}
            src={socials[1].icon}
            alt='whatsapp icon'
          />
        </a>
      </div>
    </div>
  );
};

export default FloatingBtn;
